export var PainIntensityEnum;
(function (PainIntensityEnum) {
    PainIntensityEnum["LINEAR"] = "LINEAR";
    PainIntensityEnum["WAVY"] = "WAVY";
    PainIntensityEnum["SUDDENLY"] = "SUDDENLY";
})(PainIntensityEnum || (PainIntensityEnum = {}));
//# sourceMappingURL=pain-intensity.enum.js.map